import { requestPublicCloudFunc } from "./utils";
import { MarketingData } from "@pslifestyle/common/src/types/dataProductTypes";

export const fetchMarketingData = (): Promise<MarketingData> =>
  requestPublicCloudFunc("marketingData");
